import { API_URLS, customAxios } from "../config";

export const getMenuIngredientDetails = (payload) =>
  customAxios
    .post(API_URLS.getMenuIngredientDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const addMenuIngredientDetail = (query = "") =>
  customAxios
    .get(API_URLS.addMenuIngredientDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const checkSupplierDetails = (query = "") =>
  customAxios
    .get(API_URLS.checkSupplierDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveStorageAreaDetails = (payload) =>
  customAxios
    .post(API_URLS.saveStorageAreaDetails, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);

export const getConversionMultiplierDetails = (payload) =>
  customAxios
    .post(API_URLS.getConversionMultiplierDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveMenuIngredientDetail = (payload) =>
  customAxios
    .post(API_URLS.addMenuIngredientDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const updateMenuIngredientDetail = (query, payload) =>
  customAxios
    .post(API_URLS.getEditIngredientDetail + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getInventoryUomDetail = (payload) =>
  customAxios
    .post(API_URLS.getInventoryUomDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveBackupIngredientDetail = (payload) =>
  customAxios
    .post(API_URLS.saveBackupIngredientDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getBackupIngredientDetail = (query = "") =>
  customAxios
    .get(API_URLS.getBackupIngredientDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditIngredientDetail = (query = "") =>
  customAxios
    .get(API_URLS.getEditIngredientDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getIngrRecMenuPendingApprovalDetail = (query = "") =>
  customAxios
    .get(API_URLS.getIngrRecMenuPendingApprovalDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const changePendIngredientStatusDetail = (payload) =>
  customAxios
    .post(API_URLS.changePendIngredientStatusDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const changeIngredientStatusDetail = (payload) =>
  customAxios
    .post(API_URLS.changeIngredientStatusDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// Recipe
export const getMenuRecipeDetails = (payload) =>
  customAxios
    .post(API_URLS.getMenuRecipeDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const addMenuRecipeDetail = (query = "") =>
  customAxios
    .get(API_URLS.addMenuRecipeDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getMeasurementUnitDetails = (query = "") =>
  customAxios
    .get(API_URLS.getMeasurementUnitDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getRecipeCostPriceDetails = (payload) =>
  customAxios
    .post(API_URLS.getRecipeCostPriceDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getRecipeMultiplierDetails = (payload) =>
  customAxios
    .post(API_URLS.getRecipeMultiplierDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getRecipeUnitPriceDetails = (payload) =>
  customAxios
    .post(API_URLS.getRecipeUnitPriceDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveMenuRecipeDetail = (payload) =>
  customAxios
    .post(API_URLS.addMenuRecipeDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const updateMenuRecipeDetail = (query, payload) =>
  customAxios
    .post(API_URLS.getEditRecipeDetail + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditRecipeDetail = (query) =>
  customAxios
    .get(API_URLS.getEditRecipeDetail + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const changePendRecipeStatusDetail = (payload) =>
  customAxios
    .post(API_URLS.changePendRecipeStatusDetail, payload)
    .then((res) => res?.data)
    .catch((error) => error);

//Menu Item
export const getMenuItemsDetails = (payload) =>
  customAxios
    .post(API_URLS.getMenuItemsDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuItemSubClassDetails = (payload) =>
  customAxios
    .post(API_URLS.getMenuItemSubClassDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuItemSubCategoryDetails = (payload) =>
  customAxios
    .post(API_URLS.getMenuItemSubCategoryDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const updateMenuItemClassDetails = (payload) =>
  customAxios
    .post(API_URLS.updateMenuItemClassDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const updateMenuItemCategoryDetails = (payload) =>
  customAxios
    .post(API_URLS.updateMenuItemCategoryDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const updateMenuItemStatusDetails = (payload) =>
  customAxios
    .post(API_URLS.updateMenuItemStatusDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editMenuItemLifespanDetails = (payload) =>
  customAxios
    .post(API_URLS.editMenuItemLifespanDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const updateMenuItemLifespanDetails = (payload) =>
  customAxios
    .post(API_URLS.updateMenuItemLifespanDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuPricingDetails = (payload) =>
  customAxios
    .get(API_URLS.getMenuPricingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postMenuPricingDetails = (payload) =>
  customAxios
    .post(API_URLS.postMenuPricingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getScheduledMenuPricingDetails = (payload) =>
  customAxios
    .post(API_URLS.getScheduledMenuPricingDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postScheduledMenuPricingDetails = (payload) =>
  customAxios.post(API_URLS.postScheduledMenuPricingDetails, payload);
export const getAddMenuItemDetails = (query) =>
  customAxios
    .get(API_URLS.getAddMenuItemDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuItemCaDetails = (query) =>
  customAxios
    .get(API_URLS.getMenuItemCaDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuMeasurementUnitDetails = (query) =>
  customAxios
    .get(API_URLS.getMenuMeasurementUnitDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getAddMenuPricingsDetails = (query) =>
  customAxios
    .get(API_URLS.getAddMenuPricingsDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuEditPricingsDetails = (query) =>
  customAxios
    .get(API_URLS.getMenuEditPricingsDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveAddMenuPricingsDetails = (payload) =>
  customAxios
    .post(API_URLS.saveAddMenuPricingsDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getEditMenuPricingsDetails = (query) =>
  customAxios
    .get(API_URLS.getEditMenuPricingsDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getEditMenuEditPricingsDetails = (query) =>
  customAxios
    .get(API_URLS.getEditMenuEditPricingsDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getMenuPricingListDetails = (query) =>
  customAxios
    .get(API_URLS.getMenuPricingListDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getEditMenuPricingListDetails = (query) =>
  customAxios
    .get(API_URLS.getEditMenuPricingListDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteMenuPricingsDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteMenuPricingsDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteEditMenuPricingsDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteEditMenuPricingsDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveAddMenuItemDetails = (payload) =>
  customAxios
    .post(API_URLS.getAddMenuItemDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editAddMenuItemDetails = (query, payload) =>
  customAxios
    .post(API_URLS.getEditMenuItemDetails + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const searchMenuByName = (payload) =>
  customAxios
    .get(API_URLS.searchMenuByName + payload?.query, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getSalesType = (payload) =>
  customAxios
    .post(API_URLS.getSalesType, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteScheduledMenuItem = (payload) =>
  customAxios
    .post(API_URLS.deleteScheduledMenuItem, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getMenuListDetails = (payload) =>
  customAxios
    .post(API_URLS.getMenuListDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getCostPerItemDetails = (payload) =>
  customAxios
    .post(API_URLS.getCostPerItemDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditMenuItemDetails = (query) =>
  customAxios
    .get(API_URLS.getEditMenuItemDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveEditMenuPricingsDetails = (payload) =>
  customAxios
    .post(API_URLS.saveEditMenuPricingsDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getMenuItemModifiersDetails = (query) =>
  customAxios
    .get(API_URLS.getMenuItemModifiersDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveMenuItemModifierDetails = (payload) =>
  customAxios
    .post(API_URLS.saveMenuItemModifierDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteMenuItemModifierDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteMenuItemModifierDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deleteMenuBundleItemModifierDetails = (payload) =>
  customAxios
    .post(API_URLS.deleteMenuBundleItemModifierDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getCopyBundleModifierDetails = (query) =>
  customAxios
    .get(API_URLS.getCopyBundleModifierDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getBundleModifierForCopyDetails = (query) =>
  customAxios
    .get(API_URLS.getBundleModifierForCopyDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveCopyBundleModifier = (query = "", payload) =>
  customAxios
    .post(API_URLS.saveCopyBundleModifier + query, payload)
    .then((res) => res?.data)
    .catch((error) => error);

    export const editMenuBundleItemModifierDetails = (query) =>
    customAxios
      .get(API_URLS.editMenuBundleItemModifierDetails + query)
      .then((res) => res?.data)
      .catch((error) => error);    

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  deleteScheduledMenuItem,
  getSalesType,
  searchMenuByName,
  postScheduledMenuPricingDetails,
  getScheduledMenuPricingDetails,
  getMenuPricingDetails,
  postMenuPricingDetails,
  getMenuIngredientDetails,
  addMenuIngredientDetail,
  checkSupplierDetails,
  saveStorageAreaDetails,
  getConversionMultiplierDetails,
  saveMenuIngredientDetail,
  getInventoryUomDetail,
  saveBackupIngredientDetail,
  updateMenuIngredientDetail,
  getBackupIngredientDetail,
  getEditIngredientDetail,
  getIngrRecMenuPendingApprovalDetail,
  changePendIngredientStatusDetail,
  changeIngredientStatusDetail,
  getMenuRecipeDetails,
  addMenuRecipeDetail,
  getMeasurementUnitDetails,
  getRecipeCostPriceDetails,
  getRecipeMultiplierDetails,
  getRecipeUnitPriceDetails,
  saveMenuRecipeDetail,
  updateMenuRecipeDetail,
  getEditRecipeDetail,
  changePendRecipeStatusDetail,
  getMenuItemsDetails,
  getMenuItemSubClassDetails,
  getMenuItemSubCategoryDetails,
  updateMenuItemClassDetails,
  updateMenuItemCategoryDetails,
  updateMenuItemStatusDetails,
  editMenuItemLifespanDetails,
  updateMenuItemLifespanDetails,
  getAddMenuItemDetails,
  getMenuItemCaDetails,
  getMenuMeasurementUnitDetails,
  getAddMenuPricingsDetails,
  getMenuEditPricingsDetails,
  saveAddMenuPricingsDetails,
  getMenuPricingListDetails,
  getEditMenuPricingListDetails,
  getEditMenuPricingsDetails,
  getEditMenuEditPricingsDetails,
  deleteMenuPricingsDetails,
  deleteEditMenuPricingsDetails,
  saveAddMenuItemDetails,
  editAddMenuItemDetails,
  getMenuListDetails,
  getCostPerItemDetails,
  getEditMenuItemDetails,
  saveEditMenuPricingsDetails,
  getMenuItemModifiersDetails,
  saveMenuItemModifierDetails,
  deleteMenuItemModifierDetails,
  deleteMenuBundleItemModifierDetails,
  getCopyBundleModifierDetails,
  getBundleModifierForCopyDetails,
  saveCopyBundleModifier,
  editMenuBundleItemModifierDetails,
};
